import axios from 'axios'

import {
  ApiType,
  getAxiosConfiguration,
  requestHandler,
  responseHandler,
  errorHandler
} from './configuration'

const axiosConfiguration = getAxiosConfiguration(ApiType.Login)
const loginApiClient = axios.create(axiosConfiguration)

loginApiClient.interceptors.request.use(requestHandler, errorHandler)
loginApiClient.interceptors.response.use(responseHandler, errorHandler)

export { loginApiClient }
